import Franchise from '@/components/Franchise';

export default Franchise;
export async function getServerSideProps(context) {
  if (
    context &&
    context.query &&
    Object.keys(context.query).includes('_escaped_fragment_') &&
    context.query._escaped_fragment_.length > 1
  ) {
    context.res.statusCode = 302;
    context.res.setHeader('Location', `/`);
    return {
      notFound: true,
    };
  }

  try {
    const [res, res_seo] = await Promise.all([
      fetch(
        `${process.env.API_SERVER_URL_LOCAL}/app/setting/get-web-franchise`,
        {
          headers: {
            'Content-Type': 'application/json',
            language: context.locale,
          },
        },
      ),
      fetch(
        `${process.env.API_SERVER_URL_LOCAL}/app/post/text-footer?url=/franchise`,
        {
          headers: {
            'Content-Type': 'application/json',
            language: context.locale,
          },
        },
      )
    ]);

    const listData = await res.json();
    const seo = await res_seo.json();

    if (!listData || listData.code !== 200 || !seo || seo.code !== 200) {
      return {
        notFound: true,
      };
    }
    return {
      props: {
        listData: listData.data || [],
        seo: seo.data || {}
      },
    };
  } catch (error) {
    return {
      notFound: true,
    };
  }
}
